import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useTbkProductsDetailQuery } from "../../../API/Model/useFilterModel";
import {
  Col,
  Container,
  Row,
  Tab,
  Tabs,
  Nav,
  Button,
  Modal,
  Form,
  Spinner,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import styles from "./TbkProduct.module.css";
import { getImageUrl, handleCheckUserLogin } from "../../../MIS/Global";
import SizePriceList from "./SizePriceList";
import { FaExclamationTriangle, FaExclamationCircle } from "react-icons/fa";
import { FaShareAlt } from "react-icons/fa"; // Share Icon
import CustomTabs from "./CustomTabs";
import { getSettings } from "../../../API/Service/settingServices";
import { getUsers } from "../../../API/Service/userLoginService";
import { calculateCGST_SGST, dynamicSum, getSumByKey, quotationSave } from "../../../API/Service/quotationService";
import { setUserLoginModal } from "../../../API/Reducer/userReducer";
import useToast from "../../../API/GlobalHooks/useToast";
import { handleGetSingleSize_list } from "./productDetailModel";
import { decrypt, encrypt } from "../../../MIS/encryption";

const TbkProductDetailPage = () => {
  const navigate=useNavigate();
  // const { id, subid } = useParams();
  let { id, subid } = useParams();
  id=decrypt(id)
  subid=decrypt(subid)
  const dispatch = useDispatch();
  const [products, setProducts] = useState();
  const [fabricData, setFabricData] = useState([]);
  const [sizeData, setSizeData] = useState([]);
  const [singleSizeData, setSingleSizeData] = useState([]);
  const [description, setDescription] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [showModal, setShowModal] = useState(false); // State to manage modal visibility
  const [items, setItems] = useState([]);
  const [user, setUser] = useState({});
  const [gstPercent, setGstPercent] = useState(0);
  const [key, setKey] = useState("home");
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isLogin, setIsLogin] = useState(false);
  const { userLogin,userLoginModal } = useSelector((state) => state.user);
  const showToast = useToast();
  let filterPara = {
    id: id,
    subid: subid,
    action: "getProductDetail",
  };

  const { refetch: refetchTbkProductDetail } =
    useTbkProductsDetailQuery(filterPara);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await refetchTbkProductDetail();
      setProducts(response?.data?.data?.ProductData || []);      
      setFabricData(response?.data?.data?.FabricData || []);  
      setSizeData(response?.data?.data?.SizeData || []);
      const productDescriptionData =
        response?.data?.data?.ProductData?.[0]?.subp_descp;
      let cleanedData = productDescriptionData
        .replace(/'/g, '"') // Replace single quotes with double quotes
        .replace(/: False/g, ": false") // Fix booleans
        .replace(/: True/g, ": true");
      let parsedData = JSON.parse(cleanedData);
      setDescription(parsedData || []);
      setIsError(false);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id && subid) {
      fetchData();
    }
  }, [id, subid]);

  useEffect(() => {
    if (id && subid) {
    if(sizeData?.length > 0){
      handleGetSingleSize_list({setSizeData,pid:id,sizeData})
    }}
  },[sizeData]);

  const handleModalClose = () => {
    // if(userLoginModal)
    // dispatch(setUserLoginModal())
    setShowModal(false)};
  const handleModalShow = () => {
    if(isLogin===false){
      dispatch(setUserLoginModal())
      return;
    }else{
        let dt=`${id}-${subid}`;        
      if(products?.[0]?.catgid===12){
        navigate(`/order-process/${encrypt(dt)}`)
      }else{
        navigate(`/order-product/${encrypt(dt)}`)
        // setShowModal(true)
      }
    }
  };
  

  const getExtension = (mimeType) => {
    switch (mimeType) {
      case "image/jpeg":
        return "jpg";
      case "image/png":
        return "png";
      case "image/gif":
        return "gif";
      default:
        return "jpg"; // Default fallback
    }
  };

  const handleShare = async (imgUrl) => {
    try {
      if (!navigator.canShare) {
        alert("Sharing is not supported in your browser.");
        return;
      }

      // Fetch image
      const response = await fetch(imgUrl);
      const blob = await response.blob();
      const ext = getExtension(blob.type);
      const file = new File([blob], `product.${ext}`, { type: blob.type });

      // Check if files can be shared
      if (navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file], // Attach image file
          title: "Awesome Product-1",
          text: `Check out this products!`, // Text description + URL
          url: `${window.location.href}`,
        });
      } else {
        alert("Your device does not support file sharing.");
      }
    } catch (error) {
      // console.error("Error sharing:", error);
      // alert("Error sharing content.");
    }
  };

  const handleCheckIsLogin = () => {
    let isLogin = handleCheckUserLogin("userData", "id");
    return isLogin;
  };
  
  const getUserDetail = async()=>{
    try 
    {  
      let isLogin = handleCheckUserLogin("userData", "id");    
      const resData=await getUsers({id:isLogin})
      if(resData?.data?.length > 0){
        setUser(resData?.data?.[0])
      }
    } catch (error) {
      
    }  

  }
  
  useEffect(() => {
    let isLogin = handleCheckIsLogin();
    if (isLogin <= 0) {
      setIsLogin(false);
    } else {
      getUserDetail();
      setIsLogin(true);
    }
  }, [userLogin]);

  const getSettingGST = async()=>{
    try {      
      const resData=await getSettings({s_name:'gst percent'})
      if(resData?.data?.length > 0){
        setGstPercent(Number(resData?.data?.[0]?.s_value))
      }
    } catch (error) {
      
    }  

  }

  useEffect(() => {
    getSettingGST();
  },[])
  

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    
    const subTotal=getSumByKey(items, "item_amount");
    const { cgst, sgst } = calculateCGST_SGST(subTotal, gstPercent);
    const grand_total=dynamicSum(subTotal,cgst,sgst);
    // alert(subTotal)
    if(subTotal <= 0){
      alert("At least one item must have a quantity")      
      // showToast("At least one item must have a quantity.","danger");
      return;
    }
    const updatedArray = items.map(({ sid, ...rest }) => rest);
    setLoading(true);
    let data={      
      pid: user?.id,
      party_name: user?.ownerName,
      party_mob: user?.mob,
      party_state: user?.state,
      party_city: user?.city,
      party_pinCode: user?.postalCode,
      party_address: user?.address,
      quote_no: "-",
      // quote_date: "2025-05-08",
      quote_type: "quotation",
      quote_status: 0,
      sub_total: subTotal,
      discount: 0,
      gst_percent: gstPercent,
      s_gst: cgst,
      c_gst: sgst,
      grand_total: grand_total,
      paid_amount: grand_total,
      balance_amount: 0,
      login_id: user?.id,
      details:updatedArray,
      quote_type:0,
      addons_total:0,
      item_image:products?.[0]?.id,
      cloth_name:'',
      cloth_rate:0,      
      addons:[],      
    }
    // alert(JSON.stringify(data))
    // alert(JSON.stringify(items))

    try {
      const resData= await quotationSave(data);
      if(resData?.data > 0){
        showToast("Order submitted successfully", 'success');
        handleModalClose();
      }else{
        showToast("Something went wrong during registration! Please try again", 'danger');  
      }
    } catch (error) {     
      // alert(JSON.stringify(error)) 
      showToast("Something went wrong during registration! Please try again", 'danger');
    }finally {
      setLoading(false); // Hide loader
    }

    // Handle form submission logic here (e.g., send data to server)
    // console.log("Enquiry Submitted", formData);
    // setShowModal(false);
  };

  return (
    <Container fluid className={styles.container}>
      <Row className={styles.row}>      
        {isLoading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "250px" }}
          >
            <Spinner animation="border" variant="primary" />
          </div>
        ) : isError ? (
          <Col xs={12} className="d-flex justify-content-center mb-4">
            <div className={`${styles?.no_products_container} text-center`}>
              <FaExclamationCircle size={50} color="#f39c12" />
              <h2 className={styles?.no_products_text}>
                Oops! Something Went Wrong
              </h2>
              <p className={styles?.no_products_subtext}>
                We couldn't load the data. Please try again later!
              </p>
            </div>
          </Col>
        ) : products?.length > 0 ? (
          <>
            <Col xs={12} md={5} className={styles.imageContainer}>
              <img
                src={getImageUrl(`/media/${products?.[0]?.imgpath}`)}
                alt={products?.[0]?.id}
                className={styles.productImage}
              />
            </Col>
            <Col xs={12} md={7}>
              <Row>
                <Col xs={12} md={12} className={styles.section}>
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="badge bg-primary">
                      {products?.[0]?.productcode}
                    </span>

                    {/* Share icon visible only on mobile */}
                    <button
                      type="button"
                      onClick={() => {
                        handleShare(
                          getImageUrl(`/media/${products?.[0]?.imgpath}`)
                        );
                      }}
                      className="btn p-0 border-0 bg-transparent d-block d-md-none"
                    >
                      <FaShareAlt size={20} />
                    </button>

                    {/* <ShareComponent/> */}
                  </div>
                  <h3 className={styles.heading}>{products?.[0]?.mpname}</h3>
                  <h6 className={styles.subHeading}>
                    {products?.[0]?.subpname}
                  </h6>

                  <h3 className={styles.heading}>Fabric</h3>
                  <h6 className={styles.subHeading}>                    
                    {fabricData.map(item => item.fabricname).join(', ')}
                  </h6>

                  <h3 className={styles.heading}>Description</h3>
                  
                    <Row>
                      <Col sm={12}>
                        <CustomTabs
                          sizeData={sizeData}
                          description={description}
                        />
                          
                      </Col>
                    </Row>
                  
                </Col>

               
              </Row>

              {/* Enquiry Button */}              
                <Row>
                  <Col
                    xs={12}
                    md={12}
                    className={`d-flex justify-content-end align-items-center`}
                  >
                    <Button
                      variant="primary"
                      className={styles.enquiryButton}
                      onClick={handleModalShow}
                    >                     
                      Enquire Now
                    </Button>
                  </Col>
                </Row>               
            </Col>
          </>
        ) : products?.length <= 0 ? (
          <Col xs={12} className="d-flex justify-content-center mb-4">
            <div className={`${styles?.no_products_container} text-center`}>
              <FaExclamationTriangle size={50} color="#f39c12" />
              <h2 className={styles?.no_products_text}>
                Oops! No Products Available
              </h2>
              <p className={styles?.no_products_subtext}>
                We couldn't find any products matching your selection. Try
                searching for something else!
              </p>
            </div>
          </Col>
        ) : (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "250px" }}
          >
            <Spinner animation="border" variant="primary" />
          </div>
        )}
      </Row>

      {/* Modal for Enquiry */}
      <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Enquiry</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SizePriceList sizeData={sizeData}
           id={products?.[0]?.id} mpid={products?.[0]?.mpid} 
           productName={products?.[0]?.productname} 
           setItems={setItems}
           />
        </Modal.Body>
        <Modal.Footer closeButton>
          <Button variant="primary" type="submit"
           onClick={handleFormSubmit}
          >
          {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Submitting...
              </>
            ) : ( 
              <>
              Submit Enquiry
              </>                         
            )}            
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default TbkProductDetailPage;
